import styled from 'styled-components'

import { TransitionsAnim } from 'animations/Transitions'

const { modalFadeOut } = TransitionsAnim()

interface SET_STAKE_STYLED_PROPS {
  background: string
  fadeOut?: boolean
}
export const Modal = styled.div<SET_STAKE_STYLED_PROPS>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 20px 15px;
  position: absolute;
  border-radius: 18px;
  background: ${({ background }) => background};
  ${({ fadeOut }) => fadeOut && modalFadeOut};
  z-index: 2;
  p {
    font-size: 18px;
  }
`
export const SetStakeWrapper = styled.div`
  position: absolute;
  text-align: center;
`
